import { getConfig } from '../config/configuration';
import { ExternalLink } from '../engineClient/components/formControls/common/externalLink';
import { getShouldSimulateSiteViewErrorClientCookie } from '../handlers/handlerUtilities';
import './header.scss';

const { homeProtectUrl, assetsUrl, logoPath } = getConfig();

export function Header(): JSX.Element {
  const iconUrl = assetsUrl + logoPath;
  const hpLogo = (
    <div className="" title="Homeprotect logo">
      <img src={iconUrl} className="hp-logo"></img>
    </div>
  );

  return (
    <header className="container hp-header" tabIndex={-1}>
      <ExternalLink id="header-logo-link" href={homeProtectUrl} content={hpLogo} />
      {getShouldSimulateSiteViewErrorClientCookie() && (
        <span id="integration-toggle-override-indicator">SiteView Error Simulation Active</span>
      )}
      <div className="axa-logo" title="Underwritten by AXA insurance"></div>
    </header>
  );
}
